import { type AxiosResponse } from 'axios';
import { BASE_URL } from '@avanta/shared/constants/common';
import { getAnonymousToken } from '@avanta/shared/services/auth';
import { type User } from '@avanta/shared/types/users';
import { service, type ServiceRequestConfig } from '../api';

export const loginWithMagicLink = async (
  accessToken: string,
  email: string
): Promise<AxiosResponse<User>> => {
  const config: ServiceRequestConfig = {
    params: { email },
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    skipGlobalErrorHandler: true,
  };

  return service.post(`${BASE_URL}users/login/by-email`, {}, config);
};

export const requestMagicLink = async (email: string): Promise<AxiosResponse<void>> => {
  const anonymousToken = await getAnonymousToken();

  return service.post(
    `${BASE_URL}auth/magic/request`,
    {},
    {
      params: { email },
      headers: {
        Authorization: `Bearer ${anonymousToken?.data.access_token}`,
      },
    }
  );
};
